import { MyStuffFeatureContent } from './mystuff';
import { RequestContext } from '../../types/request-context';
import { DestructuredURL, Link, DVString } from './shared';

export interface FollowingArgs {
    sorter?: FollowingSorterLabel;
}

export interface FollowingOutput extends MyStuffFeatureContent {
    followings: FollowingPerson[];
    emptyMessage: EmptyFollowingMessage;
    sorterContent: FollowingSorterContent;
    discoveryLink: Link;
    header: string;
}

export interface FollowingPerson {
    id: string;
    name?: string;
    imageUrl: string;
    pdpLink: string;
    action: ToggleFollowingAction;
}

export interface EmptyFollowingMessage {
    header: string;
    message: DVString;
    iconUrl: string;
}

export interface FollowingSorterContent {
    prefix: string;
    sorters: FollowingSorter[];
}

export interface FollowingSorter {
    id: FollowingSorterLabel;
    text: string;
    isHighLighted: boolean;
    href: string;
}

export enum FollowingSorterLabel {
    FirstNameAsc = 'FirstNameAsc',
    FirstNameDesc = 'FirstNameDesc'
}

export enum ToggleFollowingTag {
    Follow = 'Follow',
    Unfollow = 'Unfollow'
}

export enum ToggleFollowingScope {
    Storefront = 'Storefront',
    TitleDetail = 'TitleDetail',
    PersonDetail = 'PersonDetail',
    FollowingDiscovery = 'FollowingDiscovery',
    FollowingMyStuff = 'FollowingMyStuff'
}

export interface ToggleFollowingAction {
    tag: ToggleFollowingTag;
    text: string;
    endpoint: DestructuredURL;
}

// ToggleFollowing
export interface ToggleFollowingInput {
    context: RequestContext;
    personId: string;
    personName?: string;
    tag: ToggleFollowingTag;
    scope: ToggleFollowingScope;
    token: string;
}

export interface ToggleFollowingOutput {
    success: boolean;
    message: string;
    newAction?: ToggleFollowingAction;
    returnUrl: string;
}


// FollowingDiscovery
export interface FollowingDiscoveryOutput {
    topActorsToFollow: FollowingPerson[];
    header: string;
    mystuffFollowingMessage: DVString;
    failureMessage?: string;
}

export interface FollowingDiscoveryInput {
    context: RequestContext;
}
